import { Machine, assign } from '@xstate/compiled';

interface Context {
  rowIdOpen: number | 'none-open';
}

type Event =
  | { type: 'PRESS_ROW_EXPAND_BUTTON'; id: number }
  | {
      type: 'CLOSE_ALL_ROWS';
    };

export const expandableRowLogicMachine = Machine<
  Context,
  Event,
  'jcapExpandableRowLogic'
>(
  {
    id: 'jcapExpandableRowLogic',
    initial: 'initial',
    states: {
      initial: {},
    },
    context: {
      rowIdOpen: 'none-open',
    },
    on: {
      PRESS_ROW_EXPAND_BUTTON: [
        {
          cond: 'thisRowIsAlreadyOpen',
          actions: 'closeAllRows',
        },
        {
          actions: 'setRowOpenToContext',
        },
      ],
      CLOSE_ALL_ROWS: {
        actions: 'closeAllRows',
      },
    },
  },
  {
    guards: {
      thisRowIsAlreadyOpen: (context, event) => {
        return event.id === context.rowIdOpen;
      },
    },
    actions: {
      closeAllRows: assign((context) => {
        return {
          rowIdOpen: 'none-open',
        };
      }),
      setRowOpenToContext: assign((context, event) => {
        return {
          rowIdOpen: event.id,
        };
      }),
    },
  },
);
